import React, { Component } from 'react'

import classNames from './AlbumEditModal.css'
import Modal from '../modals/Modal'
import ConstraintsForm from './ConstraintsForm'
import ToggleForm from '../ToggleForm'
import ConfirmButtons from '../ConfirmButtons'
import DiversityPicker from '../search/DiversityPicker'
import { isDynamicAlbum } from './utils'
import { PRESENTATION_ARRAY, SORT_ARRAY } from '../../constants'

export default class AlbumEditModal extends Component {
  state = {
    saving: false
  }
  onConfirm = () => {
    this.setState({ saving: true })
    setTimeout(this.props.onSave, 500)
  }
  render () {
    const { album, update, renderHeading, onCancel } = this.props
    return (
      <Modal title='Modify Album In This Playlist' onClose={onCancel}>
        <div className={classNames.page}>
          {this.props.renderAlbum(album, null, true)}
          {renderHeading('Modify this album’s settings (for playlist only)')}
          <ToggleForm
            showLabel='Find image settings'
            description='This overrides limits and order from search'
            indicatorValues={[ album.albumLimit, album.albumSort ]}>
            {renderHeading('Find up to this number of photos')}
            <input
              type='number'
              value={album.albumLimit || ''}
              min={1}
              className={classNames.numberInput}
              onChange={e => update('albumLimit', parseInt(e.target.value) || undefined)}
            />
            <DiversityPicker
              value={album.diversity || ''}
              onChange={e => update('diversity', parseFloat(e.target.value) || undefined)}
            />
            {renderHeading('Find in this order')}
            <select value={album.albumSort} onChange={e => update('albumSort', e.target.value || undefined)}>
              {!isDynamicAlbum(album) &&
                <option value=''>Album default{this.props.defaultSortSuffix}</option>
              }
              {SORT_ARRAY.map(option => <option key={option.value} value={option.value}>{option.name}</option>)}
            </select>
          </ToggleForm>
          <ToggleForm
            showLabel='Present image settings'
            description='This applies to the set of images returned from the search request.'
            indicatorValues={[ album.presentationType, album.presentationSort, album.presentationLimitImages, album.presentationLimitMinutes, album.repeatTimes ]}>
            {renderHeading('Presentation mode')}
            <select value={album.presentationType} onChange={e => update('presentationType', e.target.value || undefined)}>
              <option value=''>Album default{this.props.defaultPresentationTypeSuffix}</option>
              {PRESENTATION_ARRAY.map(option => <option key={option.value} value={option.value}>{option.name}</option>)}
            </select>
            {renderHeading('Presentation sort order')}
            <select value={album.presentationSort} onChange={e => update('presentationSort', e.target.value || undefined)}>
              <option value=''>Album default{this.props.defaultPresentationSortSuffix}</option>
              {SORT_ARRAY.map(option => <option key={option.value} value={option.value}>{option.name}</option>)}
            </select>
            {renderHeading('Limit presentation to number of photos')}
            <input
              type='number'
              value={album.presentationLimitImages || ''}
              min={1}
              className={classNames.numberInput}
              onChange={e => update('presentationLimitImages', parseInt(e.target.value) || undefined)}
            />
            {renderHeading('Limit to number of minutes')}
            <input
              type='number'
              value={album.presentationLimitMinutes || ''}
              min={0.1}
              className={classNames.numberInput}
              onChange={e => update('presentationLimitMinutes', parseFloat(e.target.value) || undefined)}
            />
            {renderHeading('Repeat number of times')}
            <input
              type='number'
              value={album.repeatTimes || ''}
              min={1}
              className={classNames.numberInput}
              onChange={e => update('repeatTimes', parseInt(e.target.value) || undefined)}
            />
            {album.repeatTimes >= 1 &&
              <div>
                {renderHeading('Presentation sort order (when repeated)')}
                <select value={album.presentationRepeatSort} onChange={e => update('presentationRepeatSort', e.target.value)}>
                  <option value=''>Default</option>
                  <option value='random'>Random</option>
                </select>
              </div>
            }
          </ToggleForm>
          <ConstraintsForm
            values={album}
            update={update}
            renderHeading={renderHeading}
            title='Schedule this album (optional)'
          />
          <ConfirmButtons
            onCancel={onCancel}
            onConfirm={this.onConfirm}
            confirmText={this.state.saving ? 'Updating…' : 'Update'}
            confirmDisabled={this.state.saving}
          />
        </div>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/playlist/AlbumEditModal.js